/* eslint-disable @typescript-eslint/naming-convention */
import classNames from 'clsx';
import React from 'react';

import Link from '@swf/components/Link/Link';
import RawButton from '@swf/components/StarsButton/RawButton';
import useResolver from '@swf/core/hooks/useResolver';
import type {
  SecondaryNavigationBlock,
  SupportNavigationBlock
} from '@swf/generated/cms/types/SiteHeader';

import styles from './CMSMenu.scss';
import Icon from './Icon';

type Props = (SupportNavigationBlock | SecondaryNavigationBlock) & { className?: string };

const ResolverLink: React.FC<Props> = ({ url, resolver_tag, title, className, icon }) => {
  let href = useResolver(resolver_tag);
  if (!resolver_tag) {
    href = url || '';
  }

  if (icon === 'PrimaryButton' || icon === 'SecondaryButton') {
    const variant = icon === 'PrimaryButton' ? 'primary' : 'secondary';
    return (
      <RawButton href={url} inverse size="small" variant={variant} className={styles.buttonLink}>
        {title}
      </RawButton>
    );
  }

  return (
    <Link href={href} className={classNames(className, styles.menuLink)}>
      <Icon icon={icon?.toLowerCase()} className={styles.icon} />
      {title}
    </Link>
  );
};

export default ResolverLink;
